export const isMultiSelect = (type?: string): boolean => type === 'InputMultiSelect';
